const canHover = () => typeof window !== "undefined" && window.matchMedia?.("(hover: hover) and (pointer: fine)").matches;

export function hoverCardHandlers(user) {
  if (!user?.username || !canHover()) return {};
  return {
    onMouseEnter: (e) => window.dispatchEvent(new CustomEvent("phc:show", { detail: { user, rect: e.currentTarget.getBoundingClientRect() } })),
    onMouseLeave: () => window.dispatchEvent(new CustomEvent("phc:hide")),
  };
}
